import I18n from '../../config/locales';

export const YELP_REQUEST = 'YELP_REQUEST';
export const YELP_SUCCESS = 'YELP_SUCCESS';
export const YELP_FAILURE = 'YELP_FAILURE';
export const SATE_LIST_REQUEST = 'SATE_LIST_REQUEST';
export const SATE_LIST_SUCCESS = 'SATE_LIST_SUCCESS';
export const SATE_LIST_FAILURE = 'SATE_LIST_FAILURE';
export const COMPANY_LIST_REQUEST = 'COMPANY_LIST_REQUEST';
export const COMPANY_LIST_SUCCESS = 'COMPANY_LIST_SUCCESS';
export const COMPANY_LIST_FAILURE = 'COMPANY_LIST_FAILURE';
export const GOOGLE_REVIEW_REQUEST = 'GOOGLE_REVIEW_REQUEST';
export const GOOGLE_REVIEW_SUCCESS = 'GOOGLE_REVIEW_SUCCESS';
export const GOOGLE_REVIEW_FAILURE = 'GOOGLE_REVIEW_FAILURE';
export const DELETE_COMPANY_LOGO_REQUEST = 'DELETE_COMPANY_LOGO_REQUEST';
export const UPDATE_COMPANY_LOGO_REQUEST = 'UPDATE_COMPANY_LOGO_REQUEST';
export const UPDATE_RATING_REQUEST = 'UPDATE_RATING_REQUEST';
export const UPDATE_RATING_SUCCESS = 'UPDATE_RATING_SUCCESS';
export const UPDATE_RATING_FAILURE = 'UPDATE_RATING_FAILURE';

export const companyProfileConstants = () => {
  return {
    FIELD_REQUIRED: I18n.t('company.fieldRequired'),
    VALID_EMAIL: I18n.t('company.validEmail'),
    VALID_PHONE: I18n.t('company.validPhone'),
    SUPPORT_CONTACT: I18n.t('company.supportContact'),
    SERVICE_REQUIRED: I18n.t('company.serviceRequired'),
    INSTALLATION_REQUIRED: I18n.t('company.installationRequired'),
    MIN_LENGTH: I18n.t('company.minLength'),
    MAX_LENGTH: I18n.t('company.maxLength'),
    DATE_WARNING: I18n.t('company.dateWarning'),
    CORRECT_VALUE: I18n.t('company.correctValue'),
    FEIN_LENGTH: I18n.t('company.feinLength'),
    VALID_CHAMBER: I18n.t('company.validChamberNumber')
  };
};

export const feinLink = 'https://www.irs.gov/businesses/small-businesses-self-employed/employer-id-numbers';
